import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import SearchableDropdown from "./SearchableDropdown";
import { Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

interface RelativeStepControlsProps {
    references: Reference[];
    referenceColumnOptions: SearchableDropdownOption[];
    setReferences: React.Dispatch<React.SetStateAction<Reference[]>>;
    referenceValueOptions: {[vt: string]: SearchableDropdownOption[]}; //SearchableDropdownOption[];
    relativeUnits: string;
    setRelativeUnits: React.Dispatch<React.SetStateAction<string>>;
    hideReference: boolean;
    setHideReference: React.Dispatch<React.SetStateAction<boolean>>;
    groupByRelative: string [];
    setGroupByRelative: React.Dispatch<React.SetStateAction<SearchableDropdownOption[]>>;
    groupBy: string[] | undefined;
    groupbyOptions: SearchableDropdownOption[];
    hideOptions?: boolean;
}

const RelativeStepControls: React.FC<RelativeStepControlsProps> = ({
    references,
    referenceColumnOptions,
    setReferences,
    referenceValueOptions,
    relativeUnits,
    setRelativeUnits,
    hideReference,
    setHideReference,
    groupByRelative,
    setGroupByRelative,
    groupBy,
    groupbyOptions,
    hideOptions = false,
}) => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [editingReference, setEditingReference] = useState<Reference | null>(null);
    const [dialogReferenceColumn, setDialogReferenceColumn] = useState<SearchableDropdownOption[]>([])
    const [dialogReferenceValue, setDialogReferenceValue] = useState<SearchableDropdownOption[]>([])

    const handleOpen = (reference: Reference) => {
        setEditingReference(reference);
        setDialogReferenceColumn([reference.column])
        setDialogReferenceValue([reference.value])
        setModalOpen(true)
    }

    const handleNewOpen = () => {
        setEditingReference(null);
        setDialogReferenceColumn([])
        setDialogReferenceValue([])
        setModalOpen(true);
    }


    const handleClose = () => {
        setModalOpen(false)
    }

    const handleSaveReferences = () => {
        setModalOpen(false)
        if (editingReference !== null){
            setReferences(prev => {
                return prev.map(item => item.column.value === editingReference.column.value && item.value.value === editingReference.value.value ?  {column: dialogReferenceColumn[0], value: dialogReferenceValue[0]} : item)
            })
        }
        else {

            const referenceExists = references.some((ref) => ref.value.value === dialogReferenceValue[0].value && ref.column.value === dialogReferenceColumn[0].value)
                
            if (!referenceExists){
                setReferences(prev => prev.concat([{column: dialogReferenceColumn[0], value: dialogReferenceValue[0]}]))
            }
        }
    }

    const handleRemoveReference = (reference: Reference) => {
        setReferences(prev => {
            return prev.filter(ref => !(ref.column.value === reference.column.value && ref.value.value === reference.value.value))
        })
    }
    return (
        <>
            <Box style={{ width: '100%'}} padding={1}>
                <Dialog
                    open={modalOpen}
                    onClose={handleClose}
                    fullWidth
                >
                    <DialogTitle>{editingReference !== null ? 'Edit Reference Condition' : 'Add Reference Condition'}</DialogTitle>
                    <DialogContent>
                        <Box style={{ width: '100%' }} sx={{p:1}}>
                                <SearchableDropdown
                                    fullWidth
                                    label="Column for Relative Calculation"
                                    value={dialogReferenceColumn}
                                    multiple={false}
                                    setValue={setDialogReferenceColumn}
                                    options={referenceColumnOptions}
                                    placeholder="Reference Column"
                                />
                        </Box>
                        <Box style={{ width: '100%'}} sx={{p:1}}>
                            {/* <Box style={{ width: '60%', margin:0, padding:0 }}> */}
                            <SearchableDropdown
                                fullWidth
                                label="Value To Normalize by"
                                value={dialogReferenceValue}
                                multiple={false}
                                setValue={setDialogReferenceValue}
                                options={!!dialogReferenceColumn.length ? referenceValueOptions[dialogReferenceColumn[0].value].map((value: any) => ({label: value as string, value: value as string})) : []}
                                placeholder="Reference Value"
                            />
                            {/* </Box> */}
                            {/* <Box style={{ width: '40%', margin:0, padding:10  }}>
                                <FormControl fullWidth>
                                    <InputLabel id="units-label">Units</InputLabel>
                                    <Select
                                    labelId="units-label"
                                    id="units-select"
                                    value={units}
                                    label="Units"
                                    onChange={(event) => { setUnits(event.target.value as any)}}
                                    >
                                    <MenuItem value="fold_change">Fold Change</MenuItem>
                                    <MenuItem value="log2_fold_change">log2(Fold Change)</MenuItem>
                                    <MenuItem value="percentage">%</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box> */}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" disabled={dialogReferenceColumn[0] === undefined || dialogReferenceValue[0] === undefined} onClick={handleSaveReferences}>
                        {editingReference !== null ? 'Save' : 'Add'}
                    </Button>
                    </DialogActions>
                </Dialog>

                
                <Box
                    display="flex"
                    sx={{
                        position: 'relative',
                        width: '100%',
                        border: '1px solid',
                        borderColor: 'grey.400',
                        borderRadius: '4px',       
                        padding: 2,
                        marginTop: 2,
                        paddingRight: 0
                    }}
                >
                    <Typography
                        variant="caption"          
                        sx={{
                            position: 'absolute',
                            top: '-10px',           
                            left: '12px',
                            backgroundColor: 'white',
                            paddingX: 0.5,
                        }}
                    >
                        Reference Condition
                    </Typography>

                    {/* Chips container */}
                    <Box
                        display="flex"
                        flex="1"
                        flexWrap="wrap"
                        gap={1} 
                        alignItems="center"
                    >
                        {references.length > 0 ? (
                            references.map((reference: Reference) => (
                                <Chip
                                    key={reference.value.value}
                                    label={`${reference.column.value} = ${reference.value.value}`}
                                    onDelete={() => handleRemoveReference(reference)}
                                    onClick={() => handleOpen(reference)}
                                />
                            ))
                        ) : (
                            <Typography
                                color="text.secondary"
                            >
                                Add relative reference condition
                            </Typography>
                        )}
                    </Box>

                    <Box 
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ width: '40px' }}
                    >
                        <Tooltip title="Add Reference Condition">
                            <IconButton
                                color="default"
                                onClick={handleNewOpen}
                                sx={{ 
                                color: 'grey',
                                '& .MuiSvgIcon-root': { fontSize: '20px' },
                                }}
                            >
                                <AddIcon />
                            </IconButton>
                        </Tooltip>                                    
                    </Box>
                </Box>

            </Box>
            
            <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} sx={{marginTop: 2}}>
                <Box sx={{ width: '50%', p:1,}}>
                    <FormControl fullWidth>
                        <InputLabel id="units-label">Units</InputLabel>
                        <Select
                        labelId="units-label"
                        id="units-select"
                        value={relativeUnits}
                        label="Units"
                        // disabled={!normalizeBy.length}
                        onChange={(event) => { setRelativeUnits(event.target.value as any)}}
                        >
                            <MenuItem hidden={hideOptions} value="percentage_delta">% Delta</MenuItem>
                            <MenuItem value="fold_change">Fold Change</MenuItem>
                            <MenuItem hidden={hideOptions} value="log2_fold_change">log2(Fold Change)</MenuItem>
                            <MenuItem hidden={hideOptions} value="log2_fold_change_smooth">log2(Fold Change) smooth</MenuItem>
                            <MenuItem hidden={hideOptions} value="delta">Delta</MenuItem>
                            <MenuItem value="percentage">%</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ width:'50%', p:1, justifyContent:'right'}}>  
                    <FormControlLabel control={<Checkbox checked={hideReference} onChange={() => setHideReference(!hideReference)} />} label="Hide Reference" />
                </Box>
            </Box>
            {(!hideOptions) ? <>
                <Box style={{ width: '100%' }} sx={{p:1, marginTop: 2}}>
                    <SearchableDropdown
                        fullWidth
                        label="Select Relative Group By"
                        value={groupByRelative !== undefined && groupByRelative.length >= 1 && groupByRelative[0] !== 'dummy' ? groupByRelative.map(item => ({label: item.replace('|', ' '), value: item})) : (groupBy !== undefined ? groupBy.map(item => ({label: item.replace('|', ' '), value: item})): [])}
                        setValue={setGroupByRelative}
                        options={groupbyOptions}
                        placeholder="Relative Group By"
                    />
                </Box></>: <></>}
        </>
    )
}

export default RelativeStepControls;